
import { defineComponent } from 'vue';
import IconNoData from '@/assets/icon_nodata.png';

export default defineComponent({
  name: 'empty',
  props: {
    description: {
      type: String,
      default: '暂无数据',
    },
  },
  setup() {
    return {
      IconNoData,
    };
  },
});
